import { useMemo } from "react";
import { createAdminApi } from "../lib/api";
import { useWedding } from "../contexts/wedding-context";

export function useAdminApi() {
  const { slug } = useWedding();
  return useMemo(() => createAdminApi(slug), [slug]);
}
